// extracted by mini-css-extract-plugin
export default {"hideSubmit":"G6d8826"};